import Vue from "vue";
import MetroTile from "vue-metro-tile";
import OrganizationChart from 'vue-organization-chart';
import 'vue-organization-chart/dist/orgchart.css';
import { Component } from "vue-property-decorator";
import { initClient } from "../../api";
import { WindowType } from "../../util";
import { AccountsAPIControllerUIClient, AccountSelect } from '../backend/backendapi';
import { Entry } from "./organigram.model";

declare var window: WindowType;

@Component({
    name: 'organigram',
    components: {
        OrganizationChart,
        MetroTile
    }
})
export default class Organigram extends Vue {
    private accounts: AccountSelect | null = null;
    private boxStyle: 'ibiden' | 'simple' = window.application.kanban.organigram.boxstyle as any;
    private hidelines: boolean = window.application.kanban.organigram.hidelines;
    private orgComponent: 'orgchart' | 'metrotiles' = window.application.kanban.organigram.orgcomponent as any;

    private readonly accountAPI: AccountsAPIControllerUIClient = initClient(AccountsAPIControllerUIClient);

    async mounted(): Promise<void> {
        await this.reloadAll();
    }

    async reloadAll(): Promise<void> {
        await this.reloadAccounts();
    }

    async reloadAccounts(): Promise<void> {
        this.accounts = (await this.accountAPI.list()).result as any as AccountSelect ?? null;
    }

    get datasource(): Entry | undefined {
        let node = this.accounts?.parentList && this.accounts?.parentList[0];
        if (!node)
            return {} as any as Entry;

        return new Entry(node, this.accounts!, window.application.kanban.organigram.wideAccounts);
    }

    // Breadth first
    get metroNodes(): Entry[] {
        let node = this.accounts?.parentList && this.accounts?.parentList[0];
        if (!node)
            return [];

        const nodes: Entry[] = [];
        const queue: Entry[] = [new Entry(node, this.accounts!, window.application.kanban.organigram.wideAccounts)];
        while (queue.length !== 0) {
            let item = queue.shift()!;
            nodes.push(item);
            if (item.children) {
                queue.push(...item.children);
            }
        }
        return nodes;
    }

    private getWidth(entry: Entry): number {
        return window.application.kanban.organigram.wideAccounts.includes(entry.id) ? 500 : 64;
    }

    private nodeClick(node: Entry): void {
        let entry = node.node;
        if (!this.accounts)
            return;
        let oldSelect = this.accounts.selectedItem;
        this.accounts.selectedItem = entry.dbId;
        fetch('manager/api/account/SaveAccountSelect',
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(this.accounts)
            })
            .then(_ => {
                if (_.status != 200)
                    throw new Error(' != 200');

                //org chart update hack
                const c = this.accounts;
                this.accounts = null;
                Vue.nextTick(() => this.accounts = c);

                //emit events
                this.$emit('account-selected', entry.dbId);
            })
            .catch(error => {
                //cannot select that account
                this.accounts!.selectedItem = oldSelect;

                //org chart update hack
                const c = this.accounts;
                this.accounts = null;
                Vue.nextTick(() => this.accounts = c);
            });
    }
}
